import { onCleanup } from './cleanup.js'

export default function marquee() {
  const marqueeContainer = document.querySelector('.marquee-testimonios')
  if (!marqueeContainer) return

  const marqueeContent = marqueeContainer.querySelector('.marquee-content')
  if (!marqueeContent) return

  // Duplicar el contenido para crear el efecto infinito
  // const items = marqueeContent.innerHTML
  // marqueeContent.innerHTML = items + items

  // Control de pausa con mouse
  const onEnter = () => { marqueeContent.style.animationPlayState = 'paused' }
  const onLeave = () => { marqueeContent.style.animationPlayState = 'running' }

  marqueeContainer.addEventListener('mouseenter', onEnter)
  marqueeContainer.addEventListener('mouseleave', onLeave)

  onCleanup(() => {
    marqueeContainer.removeEventListener('mouseenter', onEnter)
    marqueeContainer.removeEventListener('mouseleave', onLeave)
  })
}
